// extracted by mini-css-extract-plugin
module.exports = {"btn":"CookiesChoicesButtons_btn__vPtn3","btn_container":"CookiesChoicesButtons_btn_container__ojmMW"};